import { supabase } from "@/integrations/supabase/client";

/**
 * Resolve a storage `file_path` to a public URL.
 * Some legacy rows store a full absolute URL (often pointing at another bucket)
 * in `file_path`. Prefixing those with the event-images bucket produced broken
 * `.../event-images/https://...` URLs that returned HTTP 400.
 */
export function resolveStorageUrl(
  filePath: string | null | undefined,
  bucket = "event-images"
): string | null {
  if (!filePath) return null;
  if (/^(https?:)?\/\//i.test(filePath) || filePath.startsWith("data:")) {
    return filePath;
  }
  return supabase.storage.from(bucket).getPublicUrl(filePath).data.publicUrl;
}
